"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._withdrawETH = exports._slash = exports._previewNodeOperatorRewards = exports._claimRagequitETH = exports._depositRagequitETH = exports._getTotalLiquidityInActiveRangeForUser = exports._totalRewardsReceived = exports._fetchZECRewards = exports._claimRewards = exports._applyForNodeOperatorClaimingRewards = exports._rageQuit = exports._recoverSigningKeyViaZEC = exports._recoverSigningKeyViaStakehouseProtocol = exports._callBackETH = exports._sendETHFromGiantPools = exports._batchRegisterBLSPublicKeysAndETH = exports._depositETH = exports._banNodeOperator = exports._batchWhitelistNodeOperators = exports._whitelistNodeOperators = exports._removeDAOFromZECCommittee = exports._addDAOToZECCommittee = exports._appointZECRepresentative = exports._appointEOARepresentative = exports._updateDAOAddress = exports._updateTotalZecBLSPublicKeyLimit = void 0;
const constants_1 = require("./constants");
const contracts_1 = require("./contracts");
const utils_1 = require("./utils");
const _updateTotalZecBLSPublicKeyLimit = (signer, newLimit) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.updateTotalZecBLSPublicKeyLimit(newLimit);
});
exports._updateTotalZecBLSPublicKeyLimit = _updateTotalZecBLSPublicKeyLimit;
const _updateDAOAddress = (signer, liquidStakingManagerAddress, previousDAOAddress, newDAOAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.updateDAOAddress((0, utils_1._add0x)(liquidStakingManagerAddress), (0, utils_1._add0x)(previousDAOAddress), (0, utils_1._add0x)(newDAOAddress));
});
exports._updateDAOAddress = _updateDAOAddress;
const _appointEOARepresentative = (signer, eoaRepresentative) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.appointEOARepresentative((0, utils_1._add0x)(eoaRepresentative));
});
exports._appointEOARepresentative = _appointEOARepresentative;
const _appointZECRepresentative = (signer, zecRepresentative) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.appointZECRepresentative((0, utils_1._add0x)(zecRepresentative));
});
exports._appointZECRepresentative = _appointZECRepresentative;
const _addDAOToZECCommittee = (signer, liquidStakingManagerAddress, daoAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.addDAOToZECCommittee((0, utils_1._add0x)(liquidStakingManagerAddress), (0, utils_1._add0x)(daoAddress));
});
exports._addDAOToZECCommittee = _addDAOToZECCommittee;
const _removeDAOFromZECCommittee = (signer, daoAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.removeDAOFromZECCommittee((0, utils_1._add0x)(daoAddress));
});
exports._removeDAOFromZECCommittee = _removeDAOFromZECCommittee;
const _whitelistNodeOperators = (signer, liquidStakingManagerAddress, nodeOperator) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.whitelistNodeOperators((0, utils_1._add0x)(nodeOperator), (0, utils_1._add0x)(liquidStakingManagerAddress));
});
exports._whitelistNodeOperators = _whitelistNodeOperators;
const _batchWhitelistNodeOperators = (signer, liquidStakingManagerAddress, nodeOperators) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    for (let i = 0; i < nodeOperators.length; ++i) {
        nodeOperators[i] = (0, utils_1._add0x)(nodeOperators[i]);
    }
    return contract.batchWhitelistNodeOperators(nodeOperators, (0, utils_1._add0x)(liquidStakingManagerAddress));
});
exports._batchWhitelistNodeOperators = _batchWhitelistNodeOperators;
const _banNodeOperator = (signer, nodeOperator) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.banNodeOperator((0, utils_1._add0x)(nodeOperator));
});
exports._banNodeOperator = _banNodeOperator;
const _depositETH = (signer, amount, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.depositETH(amount, { value: ethValue });
});
exports._depositETH = _depositETH;
const _batchRegisterBLSPublicKeysAndETH = (signer, blsPublicKeys, blsSignatures, eoaRepresentative, stakeGiantPoolFunds, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    if (blsPublicKeys.length != blsSignatures.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, utils_1._add0x)(blsPublicKeys[i]);
        blsSignatures[i] = (0, utils_1._add0x)(blsSignatures[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.batchDepositETHForStaking(blsPublicKeys, blsSignatures, (0, utils_1._add0x)(eoaRepresentative), stakeGiantPoolFunds, { value: ethValue });
});
exports._batchRegisterBLSPublicKeysAndETH = _batchRegisterBLSPublicKeysAndETH;
const _sendETHFromGiantPools = (signer, liquidStakingManagerAddress, blsPublicKeys, blsSignatures, appointNewEOARepresentative) => __awaiter(void 0, void 0, void 0, function* () {
    for (let i = 0; i < blsPublicKeys.length; ++i) {
        blsPublicKeys[i] = (0, utils_1._add0x)(blsPublicKeys[i]);
        blsSignatures[i] = (0, utils_1._add0x)(blsSignatures[i]);
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.sendETHFromGiantPools((0, utils_1._add0x)(liquidStakingManagerAddress), blsPublicKeys, blsSignatures, appointNewEOARepresentative);
});
exports._sendETHFromGiantPools = _sendETHFromGiantPools;
const _callBackETH = (signer, liquidStakingManagerAddress, blsPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.callBackETH((0, utils_1._add0x)(liquidStakingManagerAddress), (0, utils_1._add0x)(blsPublicKey));
});
exports._callBackETH = _callBackETH;
const _recoverSigningKeyViaStakehouseProtocol = (signer, liquidStakingManagerAddress, blsPublicKey, hAesPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.recoverSigningKeyViaStakehouseProtocol((0, utils_1._add0x)(liquidStakingManagerAddress), (0, utils_1._add0x)(blsPublicKey), (0, utils_1._add0x)(hAesPublicKey));
});
exports._recoverSigningKeyViaStakehouseProtocol = _recoverSigningKeyViaStakehouseProtocol;
const _recoverSigningKeyViaZEC = (signer, blsPublicKey, stakehouseAddress, hAesPublicKey) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.recoverSigningKeyViaZEC((0, utils_1._add0x)(blsPublicKey), (0, utils_1._add0x)(stakehouseAddress), (0, utils_1._add0x)(hAesPublicKey));
});
exports._recoverSigningKeyViaZEC = _recoverSigningKeyViaZEC;
const _rageQuit = (signer, blsPublicKey, finalisedEpochReport, reportSignature) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.rageQuit((0, utils_1._add0x)(blsPublicKey), finalisedEpochReport, reportSignature);
});
exports._rageQuit = _rageQuit;
const _applyForNodeOperatorClaimingRewards = (signer) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.applyForNodeOperatorClaimingRewards();
});
exports._applyForNodeOperatorClaimingRewards = _applyForNodeOperatorClaimingRewards;
const _claimRewards = (signer, liquidStakingManagerAddresses, blsPublicKeys, recipient) => __awaiter(void 0, void 0, void 0, function* () {
    if (liquidStakingManagerAddresses.length != blsPublicKeys.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < liquidStakingManagerAddresses.length; ++i) {
        liquidStakingManagerAddresses[i] = (0, utils_1._add0x)(liquidStakingManagerAddresses[i]);
        for (let j = 0; j < blsPublicKeys[i].length; ++j) {
            blsPublicKeys[i][j] = (0, utils_1._add0x)(blsPublicKeys[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.claimRewards((0, utils_1._add0x)(recipient), liquidStakingManagerAddresses, blsPublicKeys);
});
exports._claimRewards = _claimRewards;
const _fetchZECRewards = (signer, liquidStakingManagerAddresses, blsPublicKeys) => __awaiter(void 0, void 0, void 0, function* () {
    if (liquidStakingManagerAddresses.length != blsPublicKeys.length) {
        throw new Error(constants_1.customErrors.UNEQUAL_ARRAY_LENGTH);
    }
    for (let i = 0; i < liquidStakingManagerAddresses.length; ++i) {
        liquidStakingManagerAddresses[i] = (0, utils_1._add0x)(liquidStakingManagerAddresses[i]);
        for (let j = 0; j < blsPublicKeys[i].length; ++j) {
            blsPublicKeys[i][j] = (0, utils_1._add0x)(blsPublicKeys[i][j]);
        }
    }
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.fetchZECRewards(liquidStakingManagerAddresses, blsPublicKeys);
});
exports._fetchZECRewards = _fetchZECRewards;
const _totalRewardsReceived = (signer) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.totalRewardsReceived();
});
exports._totalRewardsReceived = _totalRewardsReceived;
const _getTotalLiquidityInActiveRangeForUser = (signer, userAddress) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.getTotalLiquidityInActiveRangeForUser((0, utils_1._add0x)(userAddress));
});
exports._getTotalLiquidityInActiveRangeForUser = _getTotalLiquidityInActiveRangeForUser;
const _depositRagequitETH = (signer, blsPublicKey, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.depositRagequitETH((0, utils_1._add0x)(blsPublicKey), { value: ethValue });
});
exports._depositRagequitETH = _depositRagequitETH;
const _claimRagequitETH = (signer, blsPublicKey, recipient) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.claimRagequitETH((0, utils_1._add0x)(blsPublicKey), (0, utils_1._add0x)(recipient));
});
exports._claimRagequitETH = _claimRagequitETH;
const _previewNodeOperatorRewards = (signer, nodeOperator) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.previewNodeOperatorRewards((0, utils_1._add0x)(nodeOperator));
});
exports._previewNodeOperatorRewards = _previewNodeOperatorRewards;
const _slash = (signer, stakehouseAddress, liquidStakingManagerAddress, blsPublicKey, finalisedEpochReport, reportSignature, ethValue) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.slash((0, utils_1._add0x)(stakehouseAddress), (0, utils_1._add0x)(liquidStakingManagerAddress), (0, utils_1._add0x)(blsPublicKey), finalisedEpochReport, reportSignature, { value: ethValue });
});
exports._slash = _slash;
const _withdrawETH = (signer, amount) => __awaiter(void 0, void 0, void 0, function* () {
    const contract = (yield (0, contracts_1.getContractInstance)(signer)).zec();
    return contract.withdrawETH(amount);
});
exports._withdrawETH = _withdrawETH;
